import { ActionMenu, Button, Pill, TableCell, TableRow } from '@/shared/components';
import { formatDate } from '@/shared/lib/format';
import type { CompanyResponse } from '@/shared/api';
import { COMPANY_TYPE_LABELS } from './CompanyFormDialog';

export interface CompanyRowHandlers {
  onEdit: (c: CompanyResponse) => void;
  onAssign: (c: CompanyResponse) => void;
}

export function companyRowActions(c: CompanyResponse, handlers: CompanyRowHandlers) {
  return [
    { label: 'Firma bearbeiten', icon: 'Edit' as const, onClick: () => handlers.onEdit(c) },
    {
      label: 'Apartments zuweisen',
      icon: 'Building' as const,
      onClick: () => handlers.onAssign(c),
    },
  ];
}

export function CompanyRow({
  company: c,
  ...handlers
}: { company: CompanyResponse } & CompanyRowHandlers) {
  return (
    <TableRow>
      <TableCell>
        <span className="text-ink wrap-break-word font-serif font-medium">{c.name}</span>
        {/* Das Kürzel ist die technische Kennung der Firma — Mono wie jede andere Kennung. */}
        <span className="text-ink-faint mt-0.5 block font-mono text-xs">{c.slug}</span>
      </TableCell>
      <TableCell>
        <Pill variant="default" size="sm">
          {COMPANY_TYPE_LABELS[c.type]}
        </Pill>
      </TableCell>
      <TableCell className="text-ink-soft whitespace-nowrap text-xs tabular-nums">
        {formatDate(c.createdAt)}
      </TableCell>
      <TableCell className="text-right">
        <ActionMenu
          trigger={
            <Button variant="ghost" size="sm" className="min-h-11">
              Aktionen
            </Button>
          }
          items={companyRowActions(c, handlers)}
        />
      </TableCell>
    </TableRow>
  );
}
